import shopTheLook from './rbata.shopTheLook';

const stlPromoCard = {
    pageBody:       undefined,
    targetSelector: '.js-shoppable-image',
    cacheSelectors() {
        this.pageBody = $(document.body);
    },
    bindHandler() {
        this.pageBody.on('click', this.targetSelector, (event) => {
            const dataSet = event.currentTarget.dataset
            shopTheLook.fetchStlProducts(dataSet.shopTheLookCode, undefined);
        });
    },
    initSTLModal() {
        if (!shopTheLook.stlModal) {
            shopTheLook.stlModal = $('#stlModal');
            shopTheLook.$body    = $('body');
            shopTheLook.stlModal.on('hidden.bs.modal', shopTheLook.cleanupModal);
            shopTheLook.initCartHandlers();
        }
    }
};

$(() => {
    if ($(stlPromoCard.targetSelector).length) {
        stlPromoCard.cacheSelectors();
        stlPromoCard.bindHandler();
        stlPromoCard.initSTLModal();
    }
});

export default stlPromoCard;
